import React from 'react';
import {useTranslation} from 'react-i18next';
import Label from '../../../../incase-domain/components/label/Label';
import {IElementPadding, ISlide} from '../../../../incase-domain/slide';
import {useSlideUpdateContext} from '../../../../ui/context/SetSlideUpdateContext';
import DebouncedNumberInput from '../../highlighted/common/debounced/DebouncedNumberInput';
import SymmetricInput from './SymmetricInput';

interface SlideSettingsMobileLayoutProps {
    slide: ISlide;
}

export default function SlideSettingsMobileLayout(props: SlideSettingsMobileLayoutProps): JSX.Element {
    const {slide} = props;

    const {t} = useTranslation();

    const {setSlide} = useSlideUpdateContext();

    const [gap, setGap] = React.useState(slide.gapBetweenMobileElements || 0);

    const handleGapChange = (value: number | undefined): void => {
        if (value && gap !== value) {
            setGap(value);
            const updated = {...slide, gapBetweenMobileElements: value};
            setSlide(updated);
        }
    };

    const handlePaddingChange = (value: IElementPadding): void => {
        if (JSON.stringify(slide.elementPadding) !== JSON.stringify(value)) {
            const updated = {...slide, elementPadding: value};
            setSlide(updated);
        }
    };

    return (
        <div className="u-flex u-flex-col u-gap-1">
            <div className="u-flex u-v-center u-h-between u-gap-2">
                <Label>{t('designSidepanel.gap')}</Label>
                <DebouncedNumberInput min={0} step={1} max={15} value={gap || 0} onChange={(value) => handleGapChange(value)} />
            </div>
            <SymmetricInput
                label={t('designSidepanel.padding')}
                inputs={['top', 'right', 'bottom', 'left']}
                icons={[
                    'fluent:padding-top-20-filled',
                    'fluent:padding-right-20-filled',
                    'fluent:padding-down-20-filled',
                    'fluent:padding-left-20-filled',
                ]}
                value={slide.elementPadding}
                onChange={(value) => handlePaddingChange(value as IElementPadding)}
            />
        </div>
    );
}
